
export default class PasswordPinNavigation {
    #stepForNumPad = 3;
    #baseIndexFocus = [ 1, 1 ];

    constructor() {
        this.parrentElement = document.getElementById('wizy-password-modal');
        this.elementsButton = this.parrentElement?.querySelectorAll('.hg-button');
        this.elements = [];
        this.currentSelectedElem = null;
        this.counterVerIndex = 0;

        this.makeFocusable();

        this.setFocus(...this.#baseIndexFocus);
    }

    makeFocusable(elements, rowIndex = 0) {
        let counter = 0;

        this.elementsButton.forEach((item, index) => {
            const vIndex = (index + 1) % this.#stepForNumPad === 0 ? this.counterVerIndex++ : this.counterVerIndex;
            const resultIndex = vIndex + rowIndex;
            const counterHIndex = index > 0 && index % this.#stepForNumPad === 0 ? counter = 0 : counter;

            item.dataset.vindex = resultIndex.toString();
            item.dataset.hindex = counterHIndex.toString();


            if (!this.elements[resultIndex]) {
                this.elements[resultIndex] = [];
            }

            this.elements[resultIndex][counterHIndex] = item;

            counter++;
        });
    }


    getElementIndex(item) {
        const vIndex = item?.dataset?.vindex || 0;
        const hIndex = item?.dataset?.hindex || 0;

        return this.elements[vIndex][hIndex] ? [ parseInt(vIndex, 0), parseInt(hIndex, 0) ] : [ 0, 0 ];
    }

    goToVerticalNext() {
        const currentIndex = this.getElementIndex(this.currentSelectedElem);

        const currentVIndex = currentIndex[0];
        const currentHIndex = currentIndex[1];

        const itemsLastIndex = this.elements.length - 1;
        const itemsLastIndexColumn = this.elements[currentHIndex].length - 1;

        const indexVertical = currentVIndex !== itemsLastIndex ? currentVIndex + 1 : 0;

        const indexHorizontal = currentVIndex === itemsLastIndexColumn && currentHIndex === 0 ? currentHIndex + 1
            : this.elements[currentVIndex].length !== itemsLastIndexColumn ? currentHIndex : 0;

        this.setFocus(indexVertical, indexHorizontal);
    }

    goToVerticalPrev() {
        const currentIndex = this.getElementIndex(this.currentSelectedElem);

        const currentVIndex = currentIndex[0];
        const currentHIndex = currentIndex[1];

        const itemsLastIndex = this.elements.length - 1;
        const itemsLastIndexColumn = this.elements[currentHIndex].length - 1;

        const indexVertical = currentVIndex !== 0 ? currentVIndex - 1 : itemsLastIndex;

        const indexHorizontal = currentVIndex === currentHIndex && currentHIndex === 0 ? 1
            : this.elements[currentVIndex].length !== itemsLastIndexColumn ? currentHIndex : 0;

        this.setFocus(indexVertical, indexHorizontal);
    }

    goToHorizontalNext() {
        const currentIndex = this.getElementIndex(this.currentSelectedElem);
        const currentVIndex = currentIndex[0];
        const currentHIndex = currentIndex[1];

        const lengthArray = this.elements.length - 1;
        const itemsLastIndex = this.elements[currentVIndex].length - 1;

        const indexHorizontal = currentVIndex === lengthArray && currentHIndex === itemsLastIndex ? currentHIndex - 1
            : currentHIndex !== itemsLastIndex ? currentHIndex + 1 : 0;


        this.setFocus(currentVIndex, indexHorizontal);
    }

    goToHorizontalPrev() {
        const currentIndex = this.getElementIndex(this.currentSelectedElem);
        const currentVIndex = currentIndex[0];
        const currentHIndex = currentIndex[1];

        const itemsLastIndex = this.elements[currentVIndex].length - 1;

        const indexHorizontal = this.elements[currentVIndex].length === currentVIndex
        && currentHIndex === 1 ? itemsLastIndex
            : currentHIndex !== 0 ? currentHIndex - 1 : itemsLastIndex;

        this.setFocus(currentVIndex, indexHorizontal);
    }

    setLastElement() {
        this.setFocus(...this.getElementIndex(this.elementsButton[this.elementsButton.length - 1]));
    }

    triggerClickOnBtn() {
        this.currentSelectedElem.click();
    }

    setFocus(vIndex, hIndex) {
        this.currentSelectedElem?.classList.remove('hg-keyMarker');

        this.currentSelectedElem = this.elements[vIndex][hIndex];
        this.currentSelectedElem.classList.add('hg-keyMarker');
    }

}
